import { useLocale } from 'next-intl';
import { Link } from '@/i18n/routing';
import { useSuspenseQuery } from '@apollo/client';
import { GetBlogName } from '@/query';
import { Image } from '@/component/Image';

import styles from './Item.module.css';
import { useParams } from 'next/navigation';

export const Item = ({
  title,
  headline,
  coverImage,
  content,
  date,
  author,
  hideBlog,
  slug,
}) => {
  const markup = { __html: content };
  return (
    <section className={styles.item}>
      <h1>{title}</h1>
      {headline && <p className="!pb-3">{headline}</p>}
      <div className="text-slate-500 text-base leading-[normal] mb-4">
        By {author} • {date}
      </div>
      {coverImage?.url && (
        <Image
          className={styles.img}
          src={coverImage.url}
          layout="responsive"
          width={960}
          height={600}
          alt={title}
          title={title}
        />
      )}
      <div className={styles.content} dangerouslySetInnerHTML={markup} />
      <Route title={title} hideBlog={hideBlog} />
    </section>
  );
};

const Route = ({ title, hideBlog }) => {
  const locale = useLocale();

  const params = useParams();

  const { data } = useSuspenseQuery(GetBlogName, {
    variables: { slug: params.blog, locale },
    skip: hideBlog,
    errorPolicy: 'ignore',
  });

  return (
    <div className="flex flex-wrap gap-0.5 text-sm max-sm:mt-20 mt-8">
      <Link href="/" className="text-primary-700 font-normal underline">
        Guestit
      </Link>
      <span className="icon-right_light size-6 text-center" />
      <Link href="/blogs/" className="text-slate-500 font-normal underline">
        Blogs
      </Link>
      {!hideBlog && (
        <>
          <span className="icon-right_light size-6 text-center" />
          <Link href="/blogs/" className="text-slate-500 font-normal underline">
            {data?.showBlog?.name}
          </Link>
        </>
      )}
      <span className="icon-right_light size-6 text-center" />
      <span className="text-slate-500 font-normal">{title}</span>
    </div>
  );
};
